"use client";
import React, { Fragment, useState } from "react";

import { useNavigate } from "react-router-dom";

import logo_main from "../../assets/images/logo_main.png";
import logo_main2 from "../../assets/images/logo_main2.png";
import { MenuMobile } from "../MenuMobile/MenuMobile";
import { SearchMenu } from "../SearchMenu/SearchMenu";

import {
  BurgerMobile,
  DropdownMenu,
  DropdownWrapper,
  HeaderButton,
  HeaderContainer,
  HeaderShell,
  HeaderLeft,
  HeaderMenuButton,
  HeaderRight,
  Icon,
  IconDot,
  Logo,
  MenuItem,
  MobileButton,
  SearchMobile,
  TGButton,
} from "./styles";

type HeaderProps = {
  isCLevelPage?: boolean;
};

export const Header = ({
  isCLevelPage = false
}: HeaderProps) => {
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [showMenu, setShowMenu] = useState(false);

  const navigate = useNavigate();
  const currentLogo = isCLevelPage ? logo_main2 : logo_main;

  return (
    <Fragment>
      <HeaderShell>
        <HeaderContainer $isDarkTheme={isCLevelPage}>
          <MobileButton onClick={() => setShowSearch(true)}>
            <SearchMobile $isDarkTheme={isCLevelPage} />
          </MobileButton>
          <HeaderLeft>
            <DropdownWrapper>
              <HeaderMenuButton $isDarkTheme={isCLevelPage}>
                  Консалтинг
                <Icon $isDarkTheme={isCLevelPage} />
              </HeaderMenuButton>
              <DropdownMenu $isDarkTheme={isCLevelPage}>
                <MenuItem $isDarkTheme={isCLevelPage} to="/services/cv-ready">
                  Резюме под ключ <IconDot />
                </MenuItem>
                <MenuItem $isDarkTheme={isCLevelPage} to="/services/talkitout">
                  Сессия «Выговориться» <IconDot />
                </MenuItem>
                <MenuItem $isDarkTheme={isCLevelPage} to="/services/career-consult">
                    Карьерная консультация <IconDot />
                </MenuItem>
                <MenuItem $isDarkTheme={isCLevelPage} to="/services/search-support">
                    Пакетное сопровождение «Хочу оффер» <IconDot />
                </MenuItem>
                <MenuItem $isDarkTheme={isCLevelPage} to="/services/vacancies">
                  Подписка на поиск вакансий <IconDot />
                </MenuItem>
                <MenuItem $isDarkTheme={isCLevelPage} to="/services/linkedin-boost">
                  Развитие Linkedin профиля <IconDot />
                </MenuItem>
                <MenuItem $isDarkTheme={isCLevelPage} to="/services/probation-support">
                    Сопровождение испытательного срока <IconDot />
                </MenuItem>
              </DropdownMenu>
            </DropdownWrapper>
            <HeaderButton $isDarkTheme={isCLevelPage} to="/services/it-hiring">ИТ подбор</HeaderButton>
            <HeaderButton $isDarkTheme={isCLevelPage} to="/services/c-level">Продвижение ТОП-менеджеров</HeaderButton>
          </HeaderLeft>
          <Logo src={currentLogo} onClick={() => navigate("/")}/>
          <MobileButton onClick={() => setShowMenu(true)}>
            <BurgerMobile $isDarkTheme={isCLevelPage} />
          </MobileButton>
          <HeaderRight>
            <HeaderButton $isDarkTheme={isCLevelPage} to="/services/it-training">Обучение</HeaderButton>
            <DropdownWrapper>
              <HeaderMenuButton $isDarkTheme={isCLevelPage}>О нас
                <Icon $isDarkTheme={isCLevelPage} />
              </HeaderMenuButton>
              <DropdownMenu $isDarkTheme={isCLevelPage}>
                <MenuItem $isDarkTheme={isCLevelPage} to="/company">О компании
                  <IconDot />
                </MenuItem>
                <MenuItem $isDarkTheme={isCLevelPage} to="/reviews">Отзывы
                  <IconDot />
                </MenuItem>
                <MenuItem $isDarkTheme={isCLevelPage} to="/blog">Блог
                  <IconDot />
                </MenuItem>
              </DropdownMenu>
            </DropdownWrapper>
            <HeaderMenuButton $isDarkTheme={isCLevelPage} onClick={() => setShowSearch(true)}>
              Поиск
            </HeaderMenuButton>
            <TGButton
              $isDarkTheme={isCLevelPage}
              href="https://t.me/ProhorovaConsult"
              target="_blank"
              rel="noopener noreferrer"
            >Задать вопрос в ТГ
            </TGButton>
          </HeaderRight>
        </HeaderContainer>
      </HeaderShell>
      <SearchMenu
        searchQuery={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        onClose={() => setShowSearch(false)}
        visible={showSearch}
      />
      <MenuMobile
        visible={showMenu}
        onClose={() => setShowMenu(false)}
        isCLevelPage={isCLevelPage}
      />
    </Fragment>
  );
};
